"use client";

import { Flex, Heading, Text } from "@radix-ui/themes";
import Link from "next/link";
import { env } from "next-runtime-env";
import { useEffect, useState } from "react";
import { ExclamationCircle, FlipBackArrowIcon } from "@/public/index";
import { CustomError } from "@/utils/network";

enum ErrorType {
    default = "default",
    notFoundInDB = "notFoundInDB",
}
interface ErrorMessageProps {
    error?: CustomError;
}

const header = {
    [ErrorType.default]: "Something isn't working right now",
    [ErrorType.notFoundInDB]: "We couldn't locate that number in our database.",
};

const message = {
    [ErrorType.default]: "Please try again later.",
    [ErrorType.notFoundInDB]: "Please double-check the number and try again. If the issue persists, try again later.",
};

export default function ErrorMessage({ error }: ErrorMessageProps) {
    const [errorType, setErrorType] = useState(ErrorType.default);

    useEffect(() => {
        if (error?.message?.toLowerCase()?.includes("not found in the remote database")) {
            setErrorType(ErrorType.notFoundInDB);
        }
    }, [error, error?.message]);

    return (
        <Flex justify="center" align="center" gap="2" direction="column" className="h-full bg-att-gray-200">
            <ExclamationCircle />
            <Heading className="text-att-gray-900 text-4xl text-center">{header[errorType]}</Heading>
            <Text as="p" className="text-mako-gray text-base max-w-[420px] text-center">
                {message[errorType]}
            </Text>
            {errorType === ErrorType.notFoundInDB && (
                <Link
                    href={env("NEXT_PUBLIC_BUSINESS_CENTER") || ""}
                    className="rounded-full h-11 px-[9px] py-[11px] text-sm font-medium text-att-cobalt-blue flex justify-center items-center gap-2.5">
                    <FlipBackArrowIcon /> Back to Business Center home
                </Link>
            )}
        </Flex>
    );
}
